import React from 'react';
import { Box } from '@mui/material';

// Animated light sweep for highlighted elements.
// Parent must be position:relative + overflow:hidden; this inherits its border radius.
const Shine: React.FC<{ intensity?: number }> = ({ intensity = 0.35 }) => (
  <Box
    sx={{
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none',
      overflow: 'hidden',
      borderRadius: 'inherit',
      zIndex: 0,
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        width: '45%',
        background: `linear-gradient(105deg, transparent 0%, rgba(255,255,255,${intensity}) 50%, transparent 100%)`,
        transform: 'translateX(-160%)',
        animation: 'elliottShine 4s ease-in-out infinite'
      },
      '@keyframes elliottShine': {
        '0%': { transform: 'translateX(-160%)' },
        '55%, 100%': { transform: 'translateX(320%)' }
      }
    }}
  />
);

export default Shine;
